import React, { useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import FormInput from "../../../utils/FormInput";
import "./style/finalizeNoLoginStyle.scss";
import "../../../style/feature.scss";
import "../../../style/typography.scss";
import InvoiceButtons from "./InvoiceButtons";
import { FormElementModel } from "../../models/FormElementModel";
import { invoiceForm, userPayForm } from "./inputsForm/InputPayFormModels";
import BasketSummary from "./BasketSummary";
import { useSelector } from "react-redux";
import { State } from "../../store";
import { PaymentLogos } from "../../../features/PaymentLogo";
import Timer from "./Timer";
import { useTranslation } from "react-i18next";
import ReactPixel from "react-facebook-pixel";
import useFacility from "../../../utils/hooks/useFacility";
import RecipientAndPurchaserForm from "./RecipientAndPurchaserForm";
import { FinalizeRecipient } from "../../models/FinalizeRecipient";
import ConsentInputs from "./ConsentInputs/ConsentInputs";
import { gaEvent } from "../../../utils/Analitics/ga";
import { GA_BEGIN_CHECKOUT } from "../../../utils/Analitics/gaEventsConsts";
import { canSendToFacebookPixel, canSendToGA } from "../../../utils/Analitics/analiticsConfigByFacility";
import { sendBeginCheckoutEvent, convertBasketToBeginCheckoutFormat } from "../../../utils/Analitics/GtmEvents";
import { BasketItem } from "../../models/BasketItem";
import SubmitButton from "./SubmitButton";

export type InputsFinalize = {
  firstName: string;
  lastName: string;
  email: string;
  repeatEmail: string;
  phone: string;
  city: string;
  street: string;
  houseNumber: string;
  flatNumber: string;
  zipCode: string;
  NIP: string;
  companyName: string;
  createUser: boolean;
  createInvoice: boolean;
  acceptEAktywni: boolean;
  acceptPrivacyPolicy: boolean;
  acceptStatute: boolean;
  recipient?: FinalizeRecipient;
  purchaser?: FinalizeRecipient;
};

interface IProps {
  onPayTransaction: (value: InputsFinalize) => void;
  onSaveReservation: (value: InputsFinalize) => void;
  alert: string;
  total: number;
  paymentUrl: string;
  loader: boolean;
  basket: BasketItem[];
  promoMessage: string;
  currentPromoCode: string;
}

const FinalizeNoLogin: React.FC<IProps> = ({
  onPayTransaction,
  onSaveReservation,
  alert,
  total,
  paymentUrl,
  loader,
  basket,
  promoMessage,
  currentPromoCode,
}: IProps) => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { t } = useTranslation();

  const [invoiceType, setInvoiceType] = useState<
    "noInvoice" | "customerInvoice" | "companyInvoice" | "recipientAndPurchaserInvoice"
  >("noInvoice");
  const {
    register,
    watch,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm<InputsFinalize>({});
  const zipCodeRequired = useSelector((state: State) => state.config.configuration.zipCodeRequired);
  const phoneNumberRequired = useSelector((state: State) => state.config.configuration.phoneNumberRequired);
  const facilityIds = useFacility();
  const [email, setEmail] = useState<string>();
  const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);
  const handleRegistration: SubmitHandler<InputsFinalize> = async (data) => {
    setEmail(data.email);

    // Czyszczenie pól faktury firmowej gdy nie wybrano faktury na firmę
    const cleanedData: InputsFinalize = {
      ...data,
      NIP: invoiceType === "companyInvoice" ? data.NIP : "",
      companyName: invoiceType === "companyInvoice" ? data.companyName : "",
    };

    // Zapisujemy stan koszyka lokalnie przed wykonaniem akcji
    const basketSnapshot = [...basket];
    const totalSnapshot = total;
    const promoCodeSnapshot = currentPromoCode;

    analiticsBeginCheckout(basketSnapshot, totalSnapshot, promoCodeSnapshot);

    // Guard to prevent multiple submissions, particularly for free orders (paymentUrl === "")
    setHasSubmitted(true);

    if (invoiceType === "recipientAndPurchaserInvoice") {
      onSaveReservation({ ...cleanedData, createInvoice: true });
    } else {
      onPayTransaction({ ...cleanedData, createInvoice: invoiceType !== "noInvoice" });
    }
    // pixelAddBasket();
  };

  const analiticsBeginCheckout = (
    basketSnapshot: any[],
    totalSnapshot: number,
    promoCodeSnapshot: string | undefined
  ) => {
    if (canSendToFacebookPixel(facilityIds)) {
      ReactPixel.fbq("track", "basketValueBeforePayU", {
        value: totalSnapshot,
        currency: "PLN",
      });
    }
    if (canSendToGA(facilityIds)) {
      gaEvent(
        facilityIds,
        "...",
        GA_BEGIN_CHECKOUT,
        {
          value: totalSnapshot,
          currency: "PLN",
        },
        ""
      );
    }

    // Wysyłanie GTM begin_checkout event
    try {
      const promoCode = promoCodeSnapshot && promoCodeSnapshot.length > 0 ? promoCodeSnapshot : undefined;
      const beginCheckoutData = convertBasketToBeginCheckoutFormat(basketSnapshot, totalSnapshot, promoCode);
      sendBeginCheckoutEvent(facilityIds, beginCheckoutData);
    } catch (error) {
      console.error("Error sending GTM begin_checkout event:", error);
    }
  };

  return (
    <div>
      <form className="finalize-no-login flex-between" onSubmit={handleSubmit(handleRegistration)}>
        <div className="basket-box shadow border">
          <h3>{t("dane_zamawiajacego")}</h3>

          {userPayForm(watch, register, zipCodeRequired, phoneNumberRequired).map(
            (item: FormElementModel, index: number) => (
              <FormInput key={index} {...item} errors={errors} />
            )
          )}

          {saleConfiguration.invoiceActive && (
            <>
              <h3>{t("faktura")}</h3>
              <InvoiceButtons invoiceType={invoiceType} setInvoiceType={setInvoiceType} />
            </>
          )}
        </div>

        <div className="basket-box shadow border">
          {invoiceType !== "noInvoice" && (
            <div>
              {invoiceType === "recipientAndPurchaserInvoice" ? (
                <RecipientAndPurchaserForm register={register} errors={errors} />
              ) : (
                <>
                  {" "}
                  <h3>{t("dane_do_faktury")}</h3>
                  <div className={"inputs-customer-invoice"}>
                    {invoiceForm(register, invoiceType === "companyInvoice").map(
                      (item: FormElementModel, index: number) =>
                        item.name && <FormInput key={index} {...item} errors={errors} />
                    )}
                  </div>
                </>
              )}
            </div>
          )}

          {invoiceType === "noInvoice" && (
            <ConsentInputs
              errors={errors}
              control={control}
              setValue={setValue}
              email={email}
              title={t("zgody")}
              newsletter={true}
            />
          )}
        </div>

        <div className="basket-box shadow border">
          {invoiceType !== "noInvoice" && (
            <ConsentInputs
              errors={errors}
              control={control}
              setValue={setValue}
              email={email}
              title={t("zgody")}
              newsletter={true}
            />
          )}

          <BasketSummary total={total} />

          {alert.length > 2 && <div className="alert alert-red">{alert}</div>}

          <SubmitButton loader={loader} paymentUrl={paymentUrl} hasSubmitted={hasSubmitted} />
          <Timer />

          <PaymentLogos />
        </div>
      </form>
    </div>
  );
};

export default FinalizeNoLogin;
